import React, { useState, useEffect } from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { Navigate } from 'react-router-dom';
import { auth } from '../../config/firebase';
import { userService } from '../../services/api.service';
import UserTickets from './UserTickets';
import UserSettings from './UserSettings';
import './ProfilePage.css';

const ProfilePage = () => {
    const [user] = useAuthState(auth);
    const [userDetails, setUserDetails] = useState(null);
    const [recentTickets, setRecentTickets] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [activeTab, setActiveTab] = useState('profile');

    useEffect(() => {
        const fetchUserData = async () => {
            if (!user) return;
            
            try {
                setLoading(true);
                setError(null);
                
                const [userData, ticketsData] = await Promise.all([
                    userService.getUserDetails(user.uid),
                    userService.getUserTickets(user.uid, { limit: 3 })
                ]);

                setUserDetails(userData);
                setRecentTickets(ticketsData);
            } catch (err) {
                setError(err.message);
                console.error('Error fetching user data:', err);
            } finally {
                setLoading(false);
            }
        };

        fetchUserData();
    }, [user]);

    return (
        <div className="profile-container">
            <div className="profile-header">
                <div className="profile-avatar">
                    <img src={user?.photoURL || '/default-avatar.png'} alt="Profile" />
                </div>
                <div className="profile-info">
                    <h1>{user?.displayName}</h1>
                    <p>{user?.email}</p>
                </div>
            </div>

            <div className="profile-tabs">
                <button 
                    className={`tab ${activeTab === 'profile' ? 'active' : ''}`}
                    onClick={() => setActiveTab('profile')}
                >
                    Profile Details
                </button>
                <button 
                    className={`tab ${activeTab === 'tickets' ? 'active' : ''}`}
                    onClick={() => setActiveTab('tickets')}
                >
                    Tickets
                </button>
                <button 
                    className={`tab ${activeTab === 'settings' ? 'active' : ''}`}
                    onClick={() => setActiveTab('settings')}
                >
                    Settings
                </button>
            </div>

            <div className="profile-content">
                {activeTab === 'profile' && (
                    <div className="profile-details">
                        {userDetails && (
                            <>
                                <div className="info-group">
                                    <label>Full Name</label>
                                    <p>{userDetails.firstName} {userDetails.lastName}</p>
                                </div>
                                {/* ... other user details ... */}
                            </>
                        )}
                    </div>
                )}
                {activeTab === 'tickets' && <UserTickets />}
                {activeTab === 'settings' && <UserSettings />}
            </div>
        </div>
    );
};

export default ProfilePage; 